import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles, makeStyles, Paper, Typography,
} from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { currency } from 'Helpers/Formats';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
  },
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    margin: theme.spacing(1),
  },
  labelContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginBottom: theme.spacing(2),
    maxWidth: theme.dimensions.md,
  },
  income: {
    color: theme.palette.facet.accentGreen,
    marginLeft: 'auto',
  },
  expense: {
    color: theme.palette.facet.red,
    marginLeft: 'auto',
  },
  words: {
    display: 'flex',
    minWidth: theme.dimensions.sm,
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  redBar: {
    backgroundColor: `${theme.palette.facet.red} !important`,
  },
  bar: {
    minWidth: theme.dimensions.sm,
  },
  barContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '3',
    justifyContent: 'space-around',
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
}));
export default function IncomeVsExpenseBar(props) {
  const classes = useStyles();
  const { income, expenses } = props;

  const incomeNumber = Number(income);
  const expensesNumber = Number(expenses);
  const total = incomeNumber + expensesNumber;
  const remainder = incomeNumber - expensesNumber;

  const incomeBarProgress = incomeNumber > expensesNumber ? 100 : 100 + (remainder / total) * 100;
  const expenseBarProgress = incomeNumber < expensesNumber ? 100 : 100 - (remainder / total) * 100;

  const Progressbar = withStyles(theme => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.common.white,
    },
    bar: {
      borderRadius: 5,
      backgroundColor: theme.palette.facet.accentGreen,
    },
  }))(LinearProgress);

  return (
    <div className={classes.root}>
      <Paper className={classNames(classes.paper, classes.words)}>
        <div className={classes.labelContainer}>
          <div className={classes.labelRow}>
            <Typography variant="h3">Income:</Typography>
            <Typography variant="h3" className={classes.income}>
              {currency(income)}
            </Typography>
          </div>
          <div className={classes.labelRow}>
            <Typography variant="h3">Expenses:</Typography>
            <Typography variant="h3" className={classes.expense}>
              {currency(expenses)}
            </Typography>
          </div>
          <div className={classes.labelRow}>
            <Typography variant="h3">Remainder:</Typography>
            <Typography
              variant="h3"
              className={classNames({
                [classes.income]: remainder >= 0,
                [classes.expense]: remainder < 0,
              })}
            >
              {currency(remainder)}
            </Typography>
          </div>
        </div>
        <div className={classes.barContainer}>
          <div className={classes.bar}>
            <Progressbar variant="determinate" value={incomeBarProgress} />
          </div>
          <div className={classes.bar}>
            <Progressbar
              variant="determinate"
              classes={{ bar: classes.redBar }}
              value={expenseBarProgress}
            />
          </div>
          <div className={classes.bar}>
            <Progressbar variant="determinate" value={0} />
          </div>
        </div>
      </Paper>
    </div>
  );
}

IncomeVsExpenseBar.propTypes = {
  income: PropTypes.number.isRequired,
  expenses: PropTypes.number.isRequired,
};
